import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, IconButton } from "@mui/material";
import { useDeleteGroupMutation, useGetBinsQuery } from "../../../../../shell/services/mediaManager";
import DeleteIcon from "@mui/icons-material/Delete";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
interface Props {
  open: boolean;
  onClose: () => void;
  id: string;
  groupId: string;
}
export const DeleteFolderDialog = ({
  open,
  onClose,
  id,
  groupId
}: Props) => {
  const {
    t
  } = useTranslation();
  const [deleteGroup, {
    isLoading,
    isSuccess
  }] = useDeleteGroupMutation();
  const instanceId = useSelector((state: any) => state.instance.ID);
  const ecoId = useSelector((state: any) => state.instance.ecoID);
  const {
    data: bins
  } = useGetBinsQuery({
    instanceId,
    ecoId
  });
  const history = useHistory();
  useEffect(() => {
    if (isSuccess) {
      onClose();
      if (bins.length === 1) {
        history.push(`/media`);
      } else {
        history.push(`/media/folder/${groupId}`);
      }
    }
  }, [isSuccess]);
  return <Dialog open={open} onClose={onClose} fullWidth maxWidth={"xs"} data-sentry-element="Dialog" data-sentry-component="DeleteFolderDialog" data-sentry-source-file="DeleteFolderDialog.tsx">
      <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="DeleteFolderDialog.tsx">
        <DeleteIcon color="error" sx={{
        p: 1,
        borderRadius: "20px",
        backgroundColor: "red.100",
        display: "block",
        mb: 1.5,
        width: "40px",
        height: "40px"
      }} data-sentry-element="DeleteIcon" data-sentry-source-file="DeleteFolderDialog.tsx" />
        {t("media.deleteFolderDialogTitle")}
      </DialogTitle>
      <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="DeleteFolderDialog.tsx">
        <DialogContentText data-sentry-element="DialogContentText" data-sentry-source-file="DeleteFolderDialog.tsx">
          {t("media.deleteFolderDialogMessage")}
        </DialogContentText>
      </DialogContent>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="DeleteFolderDialog.tsx">
        <Button onClick={onClose} color="inherit" data-sentry-element="Button" data-sentry-source-file="DeleteFolderDialog.tsx">
          {t("common.cancel")}
        </Button>
        <Button disabled={isLoading} variant="contained" color="error" onClick={() => {
        deleteGroup({
          id,
          groupId
        });
      }} data-sentry-element="Button" data-sentry-source-file="DeleteFolderDialog.tsx">
          {t("media.deleteFolderDialogConfirmButton")}
        </Button>
      </DialogActions>
    </Dialog>;
};